<div
    class="resize-column-field"
    webGridCellWidth
    [style.right.px]="rightStyle"
    [leftWidth]="leftWidth()"
    [rightWidth]="rightWidth()"
    [elementLeftId]="elementLeftId()"
    [elementRightId]="elementRightId()"
    (changeWidthToLeftEvent)="changeWidthToLeftEvent.emit()"
    (changeWidthToRightEvent)="changeWidthToRightEvent.emit()"
>
    <button class="resize-column-btn">
        <img src="./assets/img/websites/lpc-resize-column-icon.svg" alt="resize" />
    </button>
</div>
